import React, { useEffect, useRef } from 'react'

type Props = { 
  stream?: MediaStream;
  // 将来的にmuteの制御をいれる
}

export const Audio: React.FC<Props> = ({ stream }) => {

  const ref = useRef<HTMLAudioElement>(null)
  useEffect(() => {
    const fetch = async () => {
      if (ref?.current && stream) {
        ref.current.srcObject = stream
        await ref.current.play().catch(console.error)
      }
    }

    fetch();
  }, [stream, ref]);

  return (
    <audio ref={ref}></audio>
  )
}
